package pl.finn.forms.wouip

object wouipData {
    val listOfOptionsForReturn = listOf(
        "epuap" to "Wnioskowaną informację proszę przesłać na moją skrzynkę ePUAP",
        "Wglad" to "Wnioskowaną informację przejrzę osobiście w urzędzie",
        "Osobisty" to "Wnioskowaną informację odbiorę osobiście w urzędzie",
        "email" to "Wnioskowaną informację proszę przesłać na adres poczty elektronicznej",
        "PocztaTrad" to "Wnioskowaną informację proszę przesłać pocztą tradycyjną"

    )
    val listOfOptionsForSharing = listOf(
        "CD" to "na płycie CD",
        "DVD" to "na płycie DVD",
        "Ksero" to "w formie ksera dokumentów",
        "Inna" to "inna forma"


    )
}
